import api from '@/api';
import { InsurerContacts } from '@/components/_common/MultipleContactModal/types';
import { API_BASE_URL } from '..';
import { Insurer } from '../Insurers/Insurers.types';
import { InsurerContact } from './InsurersContact.types';

const CONTROLLER_URL = `${API_BASE_URL}/insurers`;

export async function getInsurer(id: number): Promise<Insurer> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Insurer;
}

export async function getInsurerContacts(insurerId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${insurerId}/contacts`,
    null,
  )) as unknown;

  return result as InsurerContact[];
}

export async function postInsurerContacts(data: { value: InsurerContacts }) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${data.value.insurerId}/contacts`,
    data.value,
    null,
  )) as unknown;

  return result as InsurerContact;
}

export async function putInsurerContacts(obj: InsurerContacts) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.insurerId}/contacts/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as InsurerContact;
}

export async function detailInsurerContacts(
  insurerId: number,
  contactId: number,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${insurerId}/contacts/${contactId}`,
    null,
  )) as unknown;

  return result as InsurerContact;
}

export async function removeInsurerContacts(
  insurerId: number,
  contactId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${insurerId}/contacts/${contactId}`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function removeInsurerContactDetail(
  insurerId: number,
  detailId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${insurerId}/contacts/contactDetail/${detailId}`,
    {},
    null,
  )) as unknown;

  return result as void;
}
